<div class="loading-indicator-container">
  <div class="backdrop"></div>
  <div class="circle"></div>
</div>
